<template>
  <b-nav-item-dropdown text="For Authors">
    <b-dropdown-item @click="goTo({ name: 'forAuthorsSubmissionGuidelines' })">Submission Guidelines</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'forAuthorsStyleGuidelines' })">Style Guidelines</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'forAuthorsPolicies' })">Policies</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: 'for-authors-dropdown',
    methods: {
      goTo (rO) {
        this.$router.push(rO)
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// ForAuthorsDropdownComponent.vue?08d7e172